module.exports = __webpack_public_path__ + "15ee5ffbd14349595b5711d35eb05c64.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-4.cur
// module id = 456
// module chunks = 0